import React from "react";
//#region types
import { DialogPreviewPortalProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#region components
import { Portal } from "@mui/material";
import useFileViewerContext from "../fileViewer/context/useContext";
//#endregion
import { FileConstants } from "utils/constants";

const DialogPreviewPortal: React.FC<DialogPreviewPortalProps> = (props) => {
  const filePreviewMount = document.getElementById(FileConstants.DialogPreviewElementId);
  const { setUploadedFileDimensions } = useFileViewerContext();

  React.useEffect(() => {
    if (props.previewElement) {
      // The following aspect ratio (16:9) is selected to optimize the usage of available screen space while maintaining visual clarity and consistency across various display sizes.
      setUploadedFileDimensions({ width: 1600, height: 900 });
    } else {
      setUploadedFileDimensions(undefined);
    }

    return () => {
      if (props.previewElement) {
        setUploadedFileDimensions(undefined);
      }
    };
  }, [props.previewElement, setUploadedFileDimensions]);

  return (
    <>
      {props.previewElement && filePreviewMount && <Portal container={filePreviewMount}>{props.previewElement}</Portal>}
    </>
  );
};

export default DialogPreviewPortal;
